import styles from '@/styles/sliderBarRight.module.scss'
import Link from 'next/link'
import Image from 'next/image'
import { useState, useEffect } from 'react'
import { Timer } from '@/utils/countDown'
import { CaretDownOutlined } from '@ant-design/icons'

import getConfig from 'next/config'
import systemApi from '@/service/modules/systemApi'
const { publicRuntimeConfig } = getConfig()
const apiDomain = publicRuntimeConfig.apiDomain
const imageDomain = publicRuntimeConfig.imageDomain

export default function SliderBarRight() {

  let timer = new Timer()
  interface TimeRemaining {
    days: number,
    hours: string,
    minutes: string,
    seconds: string,
    isEnd: boolean,
  }

  interface CrazyDealData {
    hoursLeft: number,
    minutesLeft: number,
    secondsLeft: number,
    filename: string,
    name: string,
    price: string,
    normalPrice: string,
    url: string
  }

  // 获取CrazyDeal数据
  const [timeDetail, setTimeDetail] = useState<string[]>([])
  const [crazyDealData, setCrazyDealData] = useState<CrazyDealData | null>(null)
  const [hasCountdown, setHasCountdown] = useState(true)

  const getCrazyDealData = async () => {
    try {
      let res: any = await systemApi.getCrazyDealOtd()
      const crazyDealData = res.data.product
      if (crazyDealData) {
        setCrazyDealData(crazyDealData || {})
        const { hoursLeft, minutesLeft, secondsLeft } = crazyDealData.crazyDeal
        // 结束时间
        const time = new Date().getTime() + (60 * 60 * hoursLeft + 60 * minutesLeft + secondsLeft) * 1000
        countDown(time)

        // 证明倒计时是有效的
        if (hoursLeft || minutesLeft || secondsLeft) {
          setHasCountdown(true)
        }
      }
    } catch (error) {
      return { notFound: true }
    }
  }

  // 倒计时计算
  function countDown(times: Date | number) {
    timer.countDown(times, (timeRemaining: TimeRemaining) => {
      if (timeRemaining.isEnd) { // 倒计时结束了
        if (hasCountdown) {
          location.reload()
        }
      } else { // 正在倒计时
        let timeDetail: string[] = []
        const { days, hours, minutes, seconds, isEnd } = timeRemaining
        if (isEnd) return
        let hh: string | number = days * 24 + parseInt(hours)
        if (hh <= 99) {
          hh < 10 ? hh = '0' + hh : hh = `${hh}`
          const [h1, h2] = hh.split('')
          timeDetail.push(h1, h2)
        } else {
          timeDetail.push('9', '9')
        }
        const [m1, m2] = minutes.split('')
        const [s1, s2] = seconds.split('')
        timeDetail = [...timeDetail, m1, m2, s1, s2]
        setTimeDetail(timeDetail)
      }
    })
  }

  useEffect(() => {
    getCrazyDealData()
  }, [])

  function handlePageJump(url: string, e: any) {
    // 阻止a标签默认行为
    e.preventDefault()
    console.log(url, ' === jump SliderBarRight');

    window.location.href = `${url}`
  }

  return (
    <>
      {
        (crazyDealData && crazyDealData != null)
        &&
        <div className={styles['slider-bar-right']} id="sliderBarRight">
          <Image
            className={styles['main-img']}
            src={`${imageDomain}/csotd-clock.png`}
            alt="Subscribe"
            priority={true}
            width={86}
            height={85}></Image>

          <div className={styles['product-box']}>
            <Link href="/crazysalesoftheday" legacyBehavior>
              <a
                onClick={(e: any) => handlePageJump(`${apiDomain}/crazysalesoftheday`, e)}
                title={crazyDealData.name}
              >
                <Image
                  className={styles['product-img']}
                  src={crazyDealData.filename}
                  alt="Subscribe"
                  priority={true}
                  width={84}
                  height={84}></Image>
                <div className={styles['product-price']}>${crazyDealData.price}</div>
              </a>
            </Link>

            <div className={styles['product-normal-price']}>was: ${crazyDealData.normalPrice}</div>

            <Link href="/crazysalesoftheday" legacyBehavior>
              <a
                onClick={(e: any) => handlePageJump(`${apiDomain}/crazysalesoftheday`, e)}
                title={crazyDealData.name}>
                <div className={styles['product-name']}>{crazyDealData.name}</div>
              </a>
            </Link>

            <div className={styles['sale-time-box']}>
              <div className={styles['sale-time-title']}>
                <CaretDownOutlined className={styles['dropdown-icon']} />
                Time Left:
              </div>

              <div className={styles['count-down']}>
                {timeDetail[0]}{timeDetail[1]}:
                {timeDetail[2]}{timeDetail[3]}:
                {timeDetail[4]}{timeDetail[5]}
              </div>
            </div>

            <Link href="/crazysalesoftheday" legacyBehavior>
              <a
                onClick={(e: any) => handlePageJump(`${apiDomain}/crazysalesoftheday`, e)}
                title={crazyDealData.name}
              >
                <div className={styles['tips-box']}>
                  <div className={styles['tips-title']}>Buy Now</div>
                  <div className={styles['tips-desc']}>Don&apos;t Miss Out</div>
                </div>
              </a>
            </Link>
          </div>
        </div>
      }
    </>
  )
}